/* ============================================================
   Rouse™ Silent Alarm — page behavior
   Loaded once by the hero section. Idempotent (safe to re-run
   on Shopify section reload events).
   ============================================================ */

(function(){
  'use strict';

  // Run after DOM is ready
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init(){
    initCarousel();
    initBuyBox();
    initFAQ();
    initFilterChips();
    initShowMore();
    initUGCVideos();
    initSocialProof();
    initStickyNav();
    initMenuOverlay();
    initSectionReload();
  });

  /* ============ SOCIAL PROOF + SHIPPING (geo-aware) ============ */
  function initSocialProof(){
    var proof = document.getElementById('rouseSocialProof');
    var dateEls = document.querySelectorAll('.r-ship-date');
    if (!proof && !dateEls.length) return;
    if (document.body.dataset.rouseSocialBound === 'true') return;
    document.body.dataset.rouseSocialBound = 'true';

    // --- Ship date = today + 2 days, e.g. "Fri, May 29" ---
    var d = new Date();
    d.setDate(d.getDate() + 2);
    var dateStr = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    [].forEach.call(dateEls, function(el){ el.textContent = dateStr; });


    // --- Name pools for English-speaking markets ---
    var pools = {
      US: ['Jacob','Emma','Michael','Olivia','Ethan','Ava','Mason','Sophia','Logan','Isabella','Liam','Mia','Noah','Madison','Aiden','Abigail'],
      GB: ['Oliver','Amelia','Harry','Isla','Jack','Ava','George','Mia','Charlie','Grace','Thomas','Poppy','Jacob','Freya','Oscar','Ella'],
      CA: ['Liam','Olivia','Noah','Emma','William','Charlotte','Benjamin','Sophia','Lucas','Ava','Jackson','Chloe'],
      AU: ['Oliver','Charlotte','William','Olivia','Jack','Amelia','Noah','Mia','Thomas','Isla','Ethan','Grace','Lachlan','Ruby'],
      NZ: ['Oliver','Charlotte','Jack','Isla','William','Amelia','Leo','Mia','Hunter','Ava','Mason','Harper'],
      IE: ['Jack','Emily','James','Emma','Daniel','Sophie','Conor','Aoife','Sean','Ciara','Liam','Grace','Cian','Saoirse']
    };
    var defaultPool = ['Alex','Sam','Jordan','Taylor','Emma','James','Sarah','Michael','Chris','Hannah','Daniel','Laura'];

    function rint(a, b){ return Math.floor(Math.random() * (b - a + 1)) + a; }
    function pick(arr){ return arr[Math.floor(Math.random() * arr.length)]; }

    // Fixed count phrase (number chosen once so it doesn't jump around)
    var boughtCount = rint(19, 34);
    function ccToFlag(cc){
      if (!cc || cc.length !== 2) return '';
      return cc.toUpperCase().replace(/./g, function(c){ return String.fromCodePoint(127397 + c.charCodeAt(0)); });
    }

    function startRotation(city, cc){
      var sp = proof ? proof.querySelector('.r-sp-text') : null;
      var inner = sp ? sp.querySelector('.r-sp-inner') : null;
      if (!sp || !inner) return;
      var pool = pools[cc] || defaultPool;
      // Colour names straight from the product's swatches (e.g. "Ocean Blue")
      var colors = [].map.call(document.querySelectorAll('.r-swatch'), function(s){ return s.getAttribute('data-name'); })
                     .filter(function(n){ return n && n.trim(); });
      function rcolor(){ return colors.length ? ' ' + pick(colors) : ''; }
      var where = city ? ' from ' + city : '';

      // Both facts live on ONE line: count + buyer, joined by a dot.
      // Only the buyer half changes so the count is always visible too.
      var countPart = '<b>' + boughtCount + '</b> bought in the last hour';
      function buyerPart(){
        if (Math.random() < 0.6){
          return '<b>' + pick(pool) + '</b>' + where + ' just ordered' + rcolor();
        }
        return '<b>' + pick(pool) + '</b>' + where + ' ordered ' + rint(4, 41) + ' min ago';
      }

      // If the line is wider than the box, gently auto-scroll it so the
      // whole sentence stays readable on narrow screens (instead of clipping).
      function fitMarquee(){
        sp.classList.remove('scroll');
        inner.style.removeProperty('--shift');
        inner.style.removeProperty('--dur');
        var over = inner.scrollWidth - sp.clientWidth;
        if (over > 12){
          inner.style.setProperty('--shift', '-' + (over + 8) + 'px');
          inner.style.setProperty('--dur', Math.max(7, Math.round(over / 22) + 6) + 's');
          sp.classList.add('scroll');
        }
      }

      // Render once and leave it — a single static buyer, no cycling.
      inner.innerHTML = countPart + '<span class="r-sp-sep"> · </span>' + buyerPart();
      fitMarquee();
    }

    // --- Geolocate via free, CORS-enabled IP services (no permission prompt) ---
    var done = false;
    function resolve(city, cc){
      if (done) return; done = true;
      var flag = ccToFlag(cc);
      if (flag) [].forEach.call(document.querySelectorAll('.r-ship-flag'), function(el){ el.textContent = flag; });
      startRotation(city, cc);
    }
    var to = setTimeout(function(){ resolve(null, null); }, 4000);

    // Primary: geojs.io — Fallback: ipapi.co (both CORS-enabled, keyless)
    fetch('https://get.geojs.io/v1/ip/geo.json')
      .then(function(r){ return r.json(); })
      .then(function(g){
        if (g && (g.city || g.country_code)){
          clearTimeout(to);
          resolve(g.city || null, g.country_code || null);
        } else {
          throw new Error('no geojs data');
        }
      })
      .catch(function(){
        fetch('https://ipapi.co/json/')
          .then(function(r){ return r.json(); })
          .then(function(g){
            clearTimeout(to);
            resolve((g && g.city) || null, (g && g.country_code) || null);
          })
          .catch(function(){ clearTimeout(to); resolve(null, null); });
      });
  }

  /* ============ UGC VIDEOS (tap to play) ============ */
  function initUGCVideos(){
    var cards = [].slice.call(document.querySelectorAll('.r-ugc.has-video'));
    if (!cards.length) return;
    var videos = cards.map(function(c){ return c.querySelector('video'); });

    cards.forEach(function(card){
      if (card.dataset.ugcBound === 'true') return;
      card.dataset.ugcBound = 'true';
      var vid = card.querySelector('video');
      if (!vid) return;
      card.addEventListener('click', function(){
        if (vid.paused){
          // Pause every other UGC video first
          videos.forEach(function(v){ if (v && v !== vid){ v.pause(); v.parentElement.classList.remove('playing'); } });
          var p = vid.play();
          if (p && p.catch) p.catch(function(){});
          card.classList.add('playing');
        } else {
          vid.pause();
          card.classList.remove('playing');
        }
      });
      vid.addEventListener('ended', function(){ card.classList.remove('playing'); });
      vid.addEventListener('pause', function(){ card.classList.remove('playing'); });
      vid.addEventListener('play', function(){ card.classList.add('playing'); });
    });
  }

  /* ============ REVIEWS: SHOW MORE (5 at a time) ============ */
  function initShowMore(){
    var btn = document.querySelector('.r-show-more');
    if (!btn) return;
    function remaining(){ return document.querySelectorAll('.r-review-card.is-hidden'); }
    if (!remaining().length){ btn.style.display = 'none'; return; }
    btn.addEventListener('click', function(){
      var hidden = [].slice.call(remaining());
      hidden.slice(0, 5).forEach(function(c){ c.classList.remove('is-hidden'); });
      if (!remaining().length) btn.style.display = 'none';
    });
  }

  /* ============ CAROUSEL ============ */
  var carousel = null; // controller, shared with the colour swatches

  function initCarousel(){
    var allSlides = [].slice.call(document.querySelectorAll('.r-slide'));
    // Rotation runs only over the non-variant ("gallery") slides.
    var slides = allSlides.filter(function(s){ return s.getAttribute('data-variant-slide') !== 'true'; });
    var dots   = [].slice.call(document.querySelectorAll('.r-dot'));
    var arrows = document.querySelectorAll('.r-carousel-dots .arrow');
    if (!slides.length) return;

    var total = slides.length;
    var current = 0;
    var timer = null;

    function activate(slideEl){
      allSlides.forEach(function(s){
        var on = s === slideEl;
        s.classList.toggle('active', on);
        var vid = s.querySelector('video');
        if (vid){
          if (on){ var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
          else {
            vid.pause();
            // Rewind while idle so the next time this slide opens it
            // plays from the start (seeking now, not mid-playback, avoids
            // interrupting an active clip).
            try { vid.currentTime = 0; } catch(e){}
          }
        }
      });
    }
    // Dot indicator is capped (e.g. at 5). When the gallery has more slides
    // than dots, map between them proportionally so the controller width is
    // fixed but the active dot still reflects roughly where we are.
    function dotIdxFor(slideIdx){
      if (!dots.length) return 0;
      if (dots.length >= total || total < 2) return Math.min(slideIdx, dots.length - 1);
      return Math.round(slideIdx * (dots.length - 1) / (total - 1));
    }
    function slideIdxFor(dotIdx){
      if (dots.length >= total || dots.length < 2) return Math.min(dotIdx, total - 1);
      return Math.round(dotIdx * (total - 1) / (dots.length - 1));
    }

    function showSlide(idx){
      current = (idx + total) % total;
      activate(slides[current]);
      var activeDot = dotIdxFor(current);
      dots.forEach(function(d, i){
        d.classList.toggle('active', i === activeDot);
        var f = d.querySelector('.fill');
        if (!f) return;
        f.style.animation = 'none';
        void f.offsetWidth;
        if (i === activeDot) f.style.animation = 'r-fill-progress 4s linear forwards';
      });
    }
    function startAuto(){
      clearInterval(timer);
      timer = setInterval(function(){ showSlide(current + 1); }, 4000);
    }
    function stopAuto(){ clearInterval(timer); }
    dots.forEach(function(d, i){
      d.addEventListener('click', function(){ showSlide(slideIdxFor(i)); startAuto(); });
    });
    arrows.forEach(function(a){
      a.addEventListener('click', function(){
        showSlide(current + parseInt(a.getAttribute('data-dir'), 10));
        startAuto();
      });
    });

    // Touch swipe — left/right on the hero advances or retreats one slide.
    var heroEl = document.querySelector('.r-hero');
    if (heroEl){
      var sx = 0, sy = 0, sw = false;
      heroEl.addEventListener('touchstart', function(e){
        if (!e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; sw = true;
      }, { passive: true });
      heroEl.addEventListener('touchend', function(e){
        if (!sw) return; sw = false;
        var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          showSlide(current + (dx < 0 ? 1 : -1));
          startAuto();
        }
      }, { passive: true });
    }

    showSlide(0);
    startAuto();

    // Show a specific media slide (e.g. a variant photo outside the rotation)
    // and pause autoplay so it stays until the shopper browses the carousel.
    carousel = {
      showMedia: function(mediaId){
        if (!mediaId) return false;
        var target = null;
        for (var i = 0; i < allSlides.length; i++){
          if (allSlides[i].getAttribute('data-media-id') === mediaId){ target = allSlides[i]; break; }
        }
        if (!target) return false;
        stopAuto();
        activate(target);
        dots.forEach(function(d){ d.classList.remove('active'); var f = d.querySelector('.fill'); if (f) f.style.animation = 'none'; });
        return true;
      }
    };
  }

  /* ============ COLOR SWATCHES ============ */
  function initBuyBox(){
    var swatches = [].slice.call(document.querySelectorAll('.r-swatch'));
    if (!swatches.length) return;

    var label    = document.getElementById('rouseColorLabel');
    var prompt   = document.getElementById('rouseColorPrompt');
    var hint     = document.getElementById('rouseQtyHint');
    var picksWrap= document.getElementById('rouseUnitPicks');
    var steppers = [].slice.call(document.querySelectorAll('#rouseQtyPills .r-qty-btn'));
    var qtyValue = document.getElementById('rouseQtyValue');
    var atc      = document.getElementById('rouseAtc');
    var form     = document.getElementById('rouseAtcForm');

    var defaultColorPrompt = prompt ? prompt.textContent : 'Choose your colour';
    var unitPrice = atc ? (parseInt(atc.getAttribute('data-unit-price'), 10) || 0) : 0;
    var currency  = (atc && atc.getAttribute('data-currency')) || 'USD';
    var atcPrefix = (atc && atc.getAttribute('data-atc-prefix')) || 'Add to Cart';
    var atcLabelEl = atc ? atc.querySelector('.r-atc-label') : null;
    var origAtcLabel = atcLabelEl ? atcLabelEl.textContent : '';

    // Single price (no volume discount) — show a running total when qty > 1.
    var priceEach  = document.getElementById('rousePriceEach');
    var priceTotal = document.getElementById('rousePriceTotal');
    var priceNow   = document.getElementById('rousePriceNow');
    var origNow    = priceNow ? priceNow.textContent : '';

    function defaultSwatch(){ return document.querySelector('.r-swatch.active') || swatches[0]; }

    var qty = 1;
    var units = [defaultSwatch()];   // one swatch element per unit
    var active = 0;                  // which unit we're currently colouring
    var interacted = false;          // leave the gallery on the first photo until the shopper acts

    function money(cents){
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e){ return ''; }
    }
    // Format to match the server-rendered price (same symbol + decimal separator),
    // so stepping quantity doesn't flip between "€49,99" and "€45.64".
    function ssrMoney(cents){
      var sym = (origNow.match(/^[^\d\s]+/) || [''])[0];
      if (!sym) return money(cents);
      var comma = /,\d{2}\s*$/.test(origNow);
      var amt = cents / 100;
      var s;
      if (amt % 1 === 0) { s = String(amt); }
      else { s = amt.toFixed(2); if (comma) s = s.replace('.', ','); }
      return sym + s;
    }

    function applyActive(){
      var s = units[active];
      swatches.forEach(function(x){ x.classList.toggle('active', x === s); });
      if (s){
        if (label) label.innerHTML = s.getAttribute('data-name') || '';
        var c = s.getAttribute('data-color');
        if (c) document.documentElement.setAttribute('data-color', c);
        if (interacted && carousel && carousel.showMedia) carousel.showMedia(s.getAttribute('data-media-id'));
      }
    }

    function renderPicks(){
      if (!picksWrap) return;
      if (qty <= 1){ picksWrap.hidden = true; picksWrap.innerHTML = ''; if (hint) hint.hidden = true; return; }
      if (hint) hint.hidden = false;
      picksWrap.hidden = false;
      picksWrap.innerHTML = '';
      units.forEach(function(s, i){
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'r-unit-chip' + (i === active ? ' active' : '');
        chip.setAttribute('data-unit', i);
        var dot = document.createElement('span');
        dot.className = 'r-unit-dot ' + (s ? ('r-sw-' + (s.getAttribute('data-color') || 'black')) : '');
        var n = document.createElement('span');
        n.className = 'r-unit-n';
        var ordinals = ['1st', '2nd', '3rd', '4th'];
        n.textContent = ordinals[i] || ((i + 1) + 'th');
        chip.appendChild(dot);
        chip.appendChild(n);
        chip.addEventListener('click', function(){ interacted = true; active = i; refresh(); });
        picksWrap.appendChild(chip);
      });
    }

    function updatePrompt(){
      if (!prompt) return;
      if (qty <= 1){ prompt.textContent = defaultColorPrompt; }
      else { prompt.textContent = 'Choose colour for bracelet ' + (active + 1) + ' of ' + qty; }
    }

    function updatePricing(){
      var total = unitPrice * qty;
      if (qty <= 1){
        if (priceEach) priceEach.hidden = true;
        if (priceTotal) priceTotal.hidden = true;
        if (atcLabelEl) atcLabelEl.textContent = origAtcLabel;
      } else {
        if (priceEach) priceEach.hidden = false;   // "each" next to the unit price
        if (priceTotal){ priceTotal.hidden = false; priceTotal.textContent = qty + ' bracelets · ' + ssrMoney(total) + ' total'; }
        if (atcLabelEl) atcLabelEl.textContent = atcPrefix + '  —  ' + ssrMoney(total);
      }
    }

    function refresh(){ applyActive(); renderPicks(); updatePrompt(); updatePricing(); }

    function setQty(n){
      n = Math.max(1, Math.min(4, n));
      var oldLen = units.length;
      if (n > oldLen){ for (var i = oldLen; i < n; i++){ units.push(units[0] || defaultSwatch()); } active = oldLen; }
      else if (n < oldLen){ units = units.slice(0, n); active = Math.min(active, n - 1); }
      qty = n;
      if (qtyValue) qtyValue.textContent = String(n);
      steppers.forEach(function(b){
        var step = parseInt(b.getAttribute('data-step'), 10);
        b.disabled = (step < 0 && n <= 1) || (step > 0 && n >= 4);
      });
      refresh();
    }

    // --- wire up ---
    swatches.forEach(function(s){
      s.addEventListener('click', function(){
        interacted = true;
        units[active] = s;
        applyActive();
        if (qty > 1){ active = (active + 1) % qty; }  // advance to next unit
        refresh();
      });
    });
    steppers.forEach(function(b){
      b.addEventListener('click', function(){ setQty(qty + parseInt(b.getAttribute('data-step'), 10)); });
    });

    // Add the chosen unit(s) to the cart, then go straight to checkout.
    function checkout(e){
      if (e) e.preventDefault();
      var counts = {};
      units.forEach(function(s){ var v = s && s.getAttribute('data-variant-id'); if (v){ counts[v] = (counts[v] || 0) + 1; } });
      var items = Object.keys(counts).map(function(v){ return { id: Number(v), quantity: counts[v] }; });
      if (!items.length){ if (form){ form.submit(); } return; }   // no variant data → normal submit
      if (atc) atc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){ window.location.href = '/checkout'; })
        .catch(function(){ if (atc) atc.disabled = false; if (form){ form.submit(); } });
    }
    if (form) form.addEventListener('submit', checkout);

    refresh();
  }

  /* ============ FAQ ACCORDION ============ */
  function initFAQ(){
    document.querySelectorAll('.r-faq-q').forEach(function(q){
      q.addEventListener('click', function(){
        q.parentElement.classList.toggle('open');
      });
    });
  }

  /* ============ FILTER CHIPS ============ */
  function initFilterChips(){
    document.querySelectorAll('.r-chip').forEach(function(c){
      c.addEventListener('click', function(){
        var chips = c.parentElement.querySelectorAll('.r-chip');
        chips.forEach(function(x){ x.classList.remove('active'); });
        c.classList.add('active');
      });
    });
  }

  /* ============ STICKY NAV (visible after scrolling past product card) ============ */
  function initStickyNav(){
    var nav = document.getElementById('rouseStickyNav');
    var anchor = document.getElementById('product');
    if (!nav || !anchor) return;
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    function onScroll(){
      var rect = anchor.getBoundingClientRect();
      // On desktop, show as soon as we leave the very top
      // On mobile, show once the product card scrolls ~30% past
      var threshold = isDesktop ? 60 : -(rect.height * 0.3);
      if (rect.top < threshold) nav.classList.add('visible');
      else nav.classList.remove('visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function(){
      isDesktop = window.matchMedia('(min-width: 769px)').matches;
      onScroll();
    });
    onScroll();
  }

  /* ============ MENU OVERLAY ============ */
  function initMenuOverlay(){
    var overlay = document.getElementById('rouseMenuOverlay');
    if (!overlay) return;

    function openMenu(){
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu(){
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-rouse-menu-open]').forEach(function(b){
      b.addEventListener('click', openMenu);
    });
    document.querySelectorAll('[data-rouse-menu-close]').forEach(function(b){
      b.addEventListener('click', closeMenu);
    });
    overlay.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(){
        closeMenu();
        // Allow native smooth scroll via :target after close transition
      });
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ============ SHOPIFY SECTION RELOAD HOOKS ============ */
  function initSectionReload(){
    if (typeof window === 'undefined') return;
    document.addEventListener('shopify:section:load', function(){
      initCarousel();
      initBuyBox();
      initFAQ();
      initFilterChips();
      initShowMore();
      initUGCVideos();
      initSocialProof();
      initStickyNav();
      initMenuOverlay();
    });
  }

  // Smooth scroll for in-page anchors
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (id.length < 2) return;
    var t = document.querySelector(id);
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

})();
